export default {"src":"/_next/static/media/tutorial-enhance.e19c50da.svg","height":102,"width":126,"blurWidth":0,"blurHeight":0};